<template>
  <div>

    <v-row v-if="chave === 2">
      <v-col cols="12" class="pl-0">
        <span class="text-subtitle-2">Recebíveis de Cartões</span>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="6" class="pl-0">
        <input-text label="Número Estabelecimento Comercial (EC)" v-model="model.NumeroEC" required />
      </v-col>
      <v-row v-for=" (cartao, i) in model.PropostaGarantiaBemFinanCartao" :key="i">
        <v-col cols="3">
          <input-select label="Credenciadora" v-model="cartao.Credenciadora" :options="$api.Estruturadas.Credenciadoras"
            required />
        </v-col>
        <v-col cols="3">
          <input-select label="Subcredenciadora" v-model="cartao.SubCredenciadora"
            :options="$api.Estruturadas.Subcredenciadoras" required />
        </v-col>
        <v-col cols="3">
          <input-select label="Arranjo" v-model="cartao.Arranjo" :options="$api.Estruturadas.Arranjos" required />
        </v-col>
        <v-col cols="2">
          <input-number label="Percentual Arranjo" v-model="cartao.PercArranjo" format="percent" max="100" required />
        </v-col>
        <v-col cols="1">
          <v-icon class="mt-4 ml-2" color="red" @click="model.PropostaGarantiaBemFinanCartao.splice(i, 1)">ph-trash
          </v-icon>
        </v-col>
      </v-row>
      <v-col cols="12" class="pt-0  pb-7 pl-0">
        <v-btn elevation="2" color="primary" @click="adicionarArranjo">Adicionar Arranjo +</v-btn>
      </v-col>
    </v-row>

      <v-row v-if="chave === 11">
        <v-col cols="12" class="pl-0">
          <span class="text-subtitle-2">Cotas de SPE</span>
          <v-divider></v-divider>
        </v-col>
        <v-col cols="4" class="pl-0">
          <input-documento cnpj label="CNPJ:" v-model="model.CNPJ" format="CNPJ" required />
        </v-col>
        <v-col cols="4">
          <input-text label="Razão Social" v-model="model.RazaoSocial" required />
        </v-col>
        <v-col cols="4" class="pr-0">
          <input-number label="Valor Capital Social" v-model="model.VlrCapitalSocial" format="currency" required />
        </v-col>
        <v-col cols="4" class="pl-0">
          <input-number label="Percentual Cotas Garantia" v-model="model.PercCotasGarantia" max="100" format="percent" required />
        </v-col>
        <v-col cols="12" class="pl-0">
          <span class="text-subtitle-2">Sócios</span>
          <v-divider></v-divider>
        </v-col>
        <v-row v-for=" (socio, i) in model.PropostaGarantiaBemFinanSocio" :key="i">
          <v-col cols="4">
            <input-text label="Nome Sócio" v-model="socio.Nome" required />
          </v-col>
          <v-col cols="4">
            <input-documento cpf label="CPF:" v-model="socio.DocumentoFederal" format="DocumentoFederal" required />
          </v-col>
          <v-col cols="4">
            <input-number label="Quantidade de Cotas" v-model="socio.QtdeCotas" required />
          </v-col>
          <v-col cols="4">
            <input-number label="Percentual Cotas" v-model="socio.PercCotas" max="100" format="percent" required />
          </v-col>
          <v-col cols="4">
            <input-number label="Valor das Cotas" v-model="socio.VlrCotas" format="currency" required />
          </v-col>
          <v-col cols="1">
            <v-icon class="mt-4 ml-2" color="red" @click="model.PropostaGarantiaBemFinanSocio.splice(i, 1)">ph-trash
            </v-icon>
          </v-col>
        </v-row>
        <v-row v-if="model.PropostaGarantiaBemFinanSocio.length > 1">
          <v-col>
            <input-number label="Quantidade Total das Cotas" :value="totalQtdeCotas" readonly />
          </v-col>
          <v-col>
            <input-number label="Percentual Total das Cotas" :value="totalPercCotas" max="100" format="percent" readonly />
          </v-col>
          <v-col>
            <input-number label="Valor Total das Cotas" :value="totalVlrCotas" format="currency" readonly />
          </v-col>
        </v-row>
        <v-col cols="12" class="pt-5 pb-5 pl-0">
          <v-btn elevation="2" color="primary" @click="adicionarSocio">Adicionar Sócio +</v-btn>
        </v-col>
      </v-row>
  </div>
</template>
<script>
export default {
  props: {
    chave: null,
    value: null,
  },
  created () {
    const th = this;
    th.$api.Multiplo.Select({ filter: { tipoRegistro: 201 } }).then(
      function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          if (response.Result) {
            try {
              th.bancos = JSON.parse(response.JSON);
              if (th.model.NroBanco) {
                const banco = th.bancos.find(p => p.ID === parseInt(th.model.NroBanco))
                th.$set(
                  th.model,
                  'Banco',
                  '(' + banco.ID + ') - ' + banco.Description
                );
              }
            } catch { }
          }
        }
      }
    );
  },
  data () {
    return {
      bancos: [],
    }
  },
  methods: {
    verificaTravaCarencia () {
      const th = this
      if (th.model.TravaCarenciaResgate) {
        th.$set(th.model, 'TravaCarencia', true)
        return true
      } else {
        this.$set(this.model, 'TravaCarenciaResgate', false)
        return false
      }
    },
    adicionarArranjo () {
      this.model.PropostaGarantiaBemFinanCartao.push({})
    },
    adicionarSocio () {
      this.model.PropostaGarantiaBemFinanSocio.push({})
    },
    selecionaBanco (banco) {
      this.$set(this.model, 'NroBanco', banco.ID);
      this.$set(
        this.model,
        'Banco',
        '(' + banco.ID + ') - ' + banco.Description
      );
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    totalQtdeCotas () {
      let soma = 0
      this.model.PropostaGarantiaBemFinanSocio.forEach(p => {
        soma += (p.QtdeCotas || 0)
      })
      return soma
    },
    totalPercCotas () {
      let soma = 0
      this.model.PropostaGarantiaBemFinanSocio.forEach(p => {
        soma += (p.PercCotas || 0)
      })
      return soma
    },
    totalVlrCotas () {
      let soma = 0
      this.model.PropostaGarantiaBemFinanSocio.forEach(p => {
        soma += (p.VlrCotas || 0)
      })
      return soma
    },
  }
}
</script>
